export default __webpack_public_path__ + "static/media/2_1.70c5b12e.jpg";